import { z } from "zod";

export const voiceConversationWebSocketSchema = {
  input: z.object({
    submissionUri: z.string(),
    currentSectionUri: z.string(),
    conversationHistory: z.array(
      z.object({
        role: z.enum(["user", "assistant"]),
        content: z.union([
          z.string(),
          z.array(
            z.union([
              z.object({
                type: z.enum(["tool_use"]),
                id: z.string(),
                name: z.string(),
                input: z.any(),
              }),
              z.object({
                type: z.enum(["tool_result"]),
                tool_use_id: z.string(),
                content: z.string(),
              }),
            ]),
          ),
        ]),
      }),
    ),
    language: z.string().optional(),
    preview: z
      .object({
        formUri: z.string(),
        responses: z.record(z.object({ value: z.any() })),
      })
      .optional(),
  }),
  output: z.union([
    z.object({
      response: z.string().optional(),
      toolUses: z
        .array(
          z.union([
            z.object({
              id: z.string(),
              type: z.enum(["fillField"]),
              fieldUri: z.string(),
              value: z.any(),
            }),
            z.object({
              id: z.string(),
              type: z.enum(["moveToNextSection"]),
            }),
            z.object({
              id: z.string(),
              type: z.enum(["submit"]),
            }),
            z.object({
              id: z.string(),
              type: z.enum(["scrollToFileField"]),
              fieldUri: z.string(),
            }),
          ]),
        )
        .optional(),
      audioUrl: z.string().optional(),
    }),
    z.object({
      type: z.string(),
      message: z.string(),
      audioUrl: z.string(),
    }),
  ]),
};

export const websocketSchemas = {
  voiceConversationWebSocket: voiceConversationWebSocketSchema,
};
